export const roundedPrice = (price: number) => Math.round(price);
